import { render, staticRenderFns } from "./label-nav.vue?vue&type=template&id=4bb38e1e&scoped=true"
import script from "./label-nav.vue?vue&type=script&lang=js"
export * from "./label-nav.vue?vue&type=script&lang=js"
import style0 from "./label-nav.vue?vue&type=style&index=0&id=4bb38e1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb38e1e",
  null
  
)

export default component.exports